import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Location } from "@angular/common";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { ActivatedRoute } from "@angular/router";
import { CreatePromoCodeDto } from "src/dto/request/create-promoCode-dto";
import { CareplusPromoCodeService } from "src/services/careplus-promo-code.service";
import { UpdatePromoCode } from "src/models/update-promo-code";
import { ReportService } from "src/services/report.service";
import * as Papa from "papaparse";

@Component({
  selector: "app-careplus-promo-code-add",
  templateUrl: "./careplus-promo-code-add.component.html",
  styleUrls: ["./careplus-promo-code-add.component.css"],
})
export class CareplusPromoCodeAddComponent implements OnInit {
  isAddPromoCode = true;
  couponCode: string;
  selectedApproval = "Auto";
  selectedBenefits: string[] = [];
  todayDate: Date = new Date();
  uploadedFileName: string = "";
  uploadedCodes: string[] = [];

  constructor(
    private location: Location,
    private _snackBar: MatSnackBar,
    private _promoCodeService: CareplusPromoCodeService,
    private activatedRoute: ActivatedRoute,
    private _reportsService: ReportService,
  ) {
    this.selectedApproval = "Auto";
  }

  safrattiPromoCodeForm = new FormGroup({
    promotionName: new FormControl<string>(undefined, Validators.required),
    isUserCodesMultiUse: new FormControl<boolean>(false, Validators.required),
    insurerCode: new FormControl<string>(undefined, Validators.required),
    couponCode: new FormControl<string>(undefined, Validators.required),
    startDate: new FormControl<Date | null>(null, Validators.required),
    endDate: new FormControl<Date | null>(null, Validators.required),
    type: new FormControl<string[]>(undefined, Validators.required),
    discountAmountValue: new FormControl<number>(undefined),
    percentageValue: new FormControl<number>(undefined),
    rewardCreditValue: new FormControl<number>(undefined),
    approvalMethod: new FormControl<string | null>("Auto", Validators.required),
    userCodes: new FormControl<string>(""),
  });

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.couponCode = params["couponCode"];
      this.isAddPromoCode = !this.couponCode;
      if (this.couponCode) {
        this.fetchPromoCode();
      }
    });
    console.log(this.safrattiPromoCodeForm);
  }

  fetchPromoCode() {
    this._promoCodeService.fetchPromoCode(this.couponCode).subscribe((res) => {
      this.selectedBenefits = res.type.split(",").map((x) => {
        return x.trim();
      });
      this.safrattiPromoCodeForm.patchValue({
        promotionName: res.promotionName,
        isUserCodesMultiUse: res.isUserCodesMultiUse,
        insurerCode: res.insurerCode,
        couponCode: res.couponCode,
        startDate: res.startDate,
        endDate: res.endDate,
        discountAmountValue: res.discountAmountValue,
        percentageValue: res.percentageValue,
        rewardCreditValue: res.rewardCreditValue,
        approvalMethod: res.approvalMethod,
        type: this.selectedBenefits,
      });
      this.safrattiPromoCodeForm.get("type")?.valueChanges.subscribe(() => {
        this.updateValidators();
      });
    });
  }

  addPromoCode() {
    const promotionName =
      this.safrattiPromoCodeForm.get("promotionName")?.value;
    const insurerCode = this.safrattiPromoCodeForm.get("insurerCode")?.value;
    const couponCode = this.safrattiPromoCodeForm.get("couponCode")?.value;
    const startDate = this.safrattiPromoCodeForm.get("startDate")?.value;
    const endDate = this.safrattiPromoCodeForm.get("endDate")?.value;
    const discountAmountValue = this.safrattiPromoCodeForm.get(
      "discountAmountValue",
    )?.value;
    const percentageValue =
      this.safrattiPromoCodeForm.get("percentageValue")?.value;
    const rewardCreditValue =
      this.safrattiPromoCodeForm.get("rewardCreditValue")?.value;
    const approvalMethod =
      this.safrattiPromoCodeForm.get("approvalMethod")?.value;

    const userCodesInput =
      this.safrattiPromoCodeForm.get("userCodes")?.value || "";
    const isUserCodesMultiUse = this.safrattiPromoCodeForm.get(
      "isUserCodesMultiUse",
    )?.value;
    // Convert "a,b,c" → ["a","b","c"]
    const userCodes = userCodesInput
      .split(",")
      .map((code: string) => code.trim())
      .filter((code: string) => code.length > 0);

    const promoCodeFormDetails: CreatePromoCodeDto = {
      promotionName,
      insurerCode,
      couponCode,
      startDate,
      endDate,
      type: this.selectedBenefits.join(","),
      discountAmountValue,
      percentageValue,
      rewardCreditValue,
      approvalMethod,
      status: true,
      userCodes,
      isUserCodesMultiUse,
    };

    this._promoCodeService
      .createPromoCode(promoCodeFormDetails)
      .subscribe((x) => {
        this._snackBar.open("Promo Code Created Successfully.");
        this.back();
      });
  }

  updatePromoCode() {
    const promotionName =
      this.safrattiPromoCodeForm.get("promotionName")?.value;
    const insurerCode = this.safrattiPromoCodeForm.get("insurerCode")?.value;
    const couponCode = this.safrattiPromoCodeForm.get("couponCode")?.value;
    const startDate = this.safrattiPromoCodeForm.get("startDate")?.value;
    const endDate = this.safrattiPromoCodeForm.get("endDate")?.value;
    const discountAmountValue = this.safrattiPromoCodeForm.get(
      "discountAmountValue",
    )?.value;
    const percentageValue =
      this.safrattiPromoCodeForm.get("percentageValue")?.value;
    const rewardCreditValue =
      this.safrattiPromoCodeForm.get("rewardCreditValue")?.value;
    const approvalMethod =
      this.safrattiPromoCodeForm.get("approvalMethod")?.value;

    const userCodesInput =
      this.safrattiPromoCodeForm.get("userCodes")?.value || "";

    const isUserCodesMultiUse = this.safrattiPromoCodeForm.get(
      "isUserCodesMultiUse",
    )?.value;
    const userCodes = userCodesInput
      .split(",")
      .map((code: string) => code.trim())
      .filter((code: string) => code.length > 0);

    const updatePromoCode: UpdatePromoCode = {
      promotionName,
      insurerCode,
      couponCode,
      startDate,
      endDate,
      type: this.selectedBenefits.join(","),
      discountAmountValue,
      percentageValue,
      rewardCreditValue,
      approvalMethod,
      status: true,
      userCodes,
      isUserCodesMultiUse,
    };

    this._promoCodeService
      .updatePromoCode(this.couponCode, updatePromoCode)
      .subscribe((_) => {
        this._snackBar.open("Promo Code Updated Successfully.");
        this.back();
      });
  }

  updateValidators() {
    const discountControl = this.safrattiPromoCodeForm.get(
      "discountAmountValue",
    );
    const percentageControl = this.safrattiPromoCodeForm.get("percentageValue");
    const rewardCreditControl =
      this.safrattiPromoCodeForm.get("rewardCreditValue");

    if (this.selectedBenefits.length === 0) {
      // Clear validators for all three controls if no benefits are selected
      discountControl.clearValidators();
      percentageControl.clearValidators();
      rewardCreditControl.clearValidators();
    } else {
      // Clear validators only for the control that corresponds to the unselected benefit
      if (!this.selectedBenefits.includes("DiscountAmount")) {
        discountControl.clearValidators();
      }
      if (!this.selectedBenefits.includes("Percentage")) {
        percentageControl.clearValidators();
      }
      if (!this.selectedBenefits.includes("RewardCredit")) {
        rewardCreditControl.clearValidators();
      }

      // Set validators only for the control that corresponds to the selected benefit
      if (this.selectedBenefits.includes("DiscountAmount")) {
        discountControl.setValidators([Validators.required]);
      }
      if (this.selectedBenefits.includes("Percentage")) {
        percentageControl.setValidators([Validators.required]);
      }
      if (this.selectedBenefits.includes("RewardCredit")) {
        rewardCreditControl.setValidators([Validators.required]);
      }
    }

    discountControl.updateValueAndValidity();
    percentageControl.updateValueAndValidity();
    rewardCreditControl.updateValueAndValidity();
  }

  back() {
    this.location.back();
  }

  dowloadZainVouchers() {
    this._reportsService.downloadCareplusPromotionUsercode(this.couponCode);
  }

  onCodesFileUpload(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    this.uploadedFileName = file.name;

    const ext = file.name.split(".").pop()?.toLowerCase();

    if (ext !== "csv") {
      this._snackBar.open("Please upload CSV file only", "Close", {
        duration: 3000,
      });
      return;
    }

    this.parseCSV(file);
  }

  parseCSV(file: File) {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (result: any) => {
        const codes = result.data
          .map((row: any) => row["Codes"] || row["codes"])
          .filter((code: string) => !!code);

        this.setUserCodes(codes);
      },
      error: () => {
        this._snackBar.open("Invalid CSV file", "Close", {
          duration: 3000,
        });
      },
    });
  }

  setUserCodes(codes: string[]) {
    this.uploadedCodes = codes;

    this.safrattiPromoCodeForm.patchValue({
      userCodes: codes.join(","),
    });

    this._snackBar.open(`${codes.length} codes added`, "OK", {
      duration: 3000,
    });
  }

  clearUploadedFile(fileInput: any) {
    this.uploadedFileName = "";
    this.uploadedCodes = [];

    this.safrattiPromoCodeForm.patchValue({
      userCodes: "",
    });

    fileInput.value = null;
  }
}
